import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from '../services/app.service';

@Injectable()
export class InthttpInterceptor implements HttpInterceptor {

  constructor(
    private _appService: AppService,
  ) {
    //console.info("[APP]","InthttpInterceptor Started succesfully");
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      this._appService.getJWT();
      this._appService.getUserLogin();    

      let token = `Bearer ${this._appService.TokenLogin}`;
      let userid = this._appService.UserLogin ? this._appService.UserLogin.id.toString(): "none";

      const headers = new HttpHeaders({ authorization: token, user: userid });  
      var requestClone = request.clone({ headers });      
      return next.handle(requestClone);    
  }
}
